// @flow
import {combineReducers} from 'redux';
import {voteBlockReducer} from './vote-block';
import type {TVoteBlockState} from './vote-block';

const reducers = {
    voteBlock: voteBlockReducer,
};

type TVoteBlockModuleState = {
    voteBlock: TVoteBlockState,
};

const voteBlockModuleReducer = combineReducers(reducers);
export {voteBlockModuleReducer};
export type {TVoteBlockModuleState};
